const TAB_KEY = 'assignedVehicles'
export default {
  data () {
    return {
      assignedVehiclesTabKey: TAB_KEY
    }
  },

  computed: {
    assignedVehiclesCreateConfig () {
      return {
        title: this.$t('base/user.assigned_vehicles'),
        key: TAB_KEY,
        validationErrors: this.validationErrors,
        tabContent: [
          {
            component: this.vehiclePickerComponent,
            dataKey: 'vehicles',
            inputFieldConfig: {
              label: this.$t('base/user.assigned_vehicles')
            }
          }
        ]
      }
    }
  }
}
